export default "__VITE_ASSET__DblTtfn___"